export default "__VITE_ASSET___Lw4Jffj__"